import React from "react"
import UserProvider from "./src/firelib/user-provider"
import GtagSetup from "./src/ga/gtag-setup"

const firebaseConfig = {
  apiKey: "AIzaSyDcSF0VKVPrxxHNTeqgTWuiaGrlafqBybc",
  authDomain: "auth-1ecca.firebaseapp.com",
  databaseURL: "https://auth-1ecca.firebaseio.com",
  projectId: "auth-1ecca",
  storageBucket: "",
  messagingSenderId: "687787009883",
  appId: "1:687787009883:web:585fd7ecb0391d34"
}

function App({children}){
    return (
      <UserProvider firebaseConfig={firebaseConfig}>
            <GtagSetup>{children}</GtagSetup>
      </UserProvider>
    )
}

export const wrapRootElement = ({ element }) => {
  // return element
  return (
    <App>{ element }</App>
  )

}